
let mutations = {
    updateUser(state, user) {
        state.user = user;
    },
    updateUserPoints(state, userPoints) {
        state.userPoints = Array.from(new Set(userPoints));
    },
    updateUserInfo(state, userInfo) {
        state.userInfo = userInfo;
    },
    updateQcssoSdk(state, qcssoSdk) {
      state.qcssoSdk = qcssoSdk;
    },
    updateIsLoggedIn(state, isLoggedIn) {
        state.isLoggedIn = isLoggedIn;
    },
    updateLoginConfirmShow(state, loginConfirmShow) {
        state.loginConfirmShow = loginConfirmShow;
    },
    updateCurrentPath(state, currentPath) {
        state.currentPath = currentPath.slice(1);
    },
    updateIsFinishQuestions(state, val) {
        state.isFinishQuestions = val;
    },
    updateIsQANotExist(state, val) {
        state.isQANotExist = val;
    },
    updateCampaign(state, val) {
        Object.assign(state.campaign, val);
    },
    setMuteNotifications(state, mute) {
        state.muteNotifications = mute;
        // Object.assign(state.muteNotifications, mute);
    }
};

export default mutations